import { MAX_DO_NOT_CONTACT_DAYS } from "./constants";

// Shared so the server's decision to hold the call and the CRM's decision to warn
// about it cannot drift apart. The date itself is releasable: an embargo "until the
// 6th" means the 6th is fine.
export const isEmbargoActive = (
    doNotContactUntil: string | null | undefined,
    today: Date = new Date(),
): boolean =>
    typeof doNotContactUntil === "string"
    && doNotContactUntil.trim() !== ""
    && doNotContactUntil > today.toISOString().slice(0, 10);

// Every entry point has to apply this, not just the form: an uncapped embargo is an
// open-ended hold on a lead we have already paid HMLR for.
export const isWithinEmbargoCap = (
    doNotContactUntil: string | null | undefined,
    today: Date = new Date(),
): boolean => {
    if (typeof doNotContactUntil !== "string" || doNotContactUntil.trim() === "") {
        return true;
    }

    const latest = new Date(today);
    latest.setUTCDate(latest.getUTCDate() + MAX_DO_NOT_CONTACT_DAYS);

    return doNotContactUntil <= latest.toISOString().slice(0, 10);
};

// A date that has already passed is not an embargo - `isEmbargoActive` correctly reads it
// as released, so nothing holds the call and nothing warns the handler. Storing it anyway
// leaves a listing that looks embargoed in SQL but was never held, which is how two
// Dignity referrals ended up queued for a release that had nothing to release. Normalise
// at the point of persistence so the column only ever holds a live hold.
export const normaliseEmbargoDate = (
    doNotContactUntil: string | null | undefined,
    today: Date = new Date(),
): string | null =>
    isEmbargoActive(doNotContactUntil, today) && typeof doNotContactUntil === "string"
        ? doNotContactUntil
        : null;
